import React from "react";
import { format } from "date-fns";
import "../styles/components/timeviewer.css";

const TimeViewer = (props) => (
  <div className="timeviewer">
    <p>From: {format(props.firstTime, "HH:mm:ss")}</p>
    <p>To: {format(props.endTime, "HH:mm:ss")}</p>
  </div>
);

export default TimeViewer;
